var OrganizationHierarchicalList;

import OrganizationHierarchicalTree from './organization_hierarchical_tree.js';

export default OrganizationHierarchicalList = Vue.extend({
  components: {
    'hierarchical-select-tree': OrganizationHierarchicalTree
  },
  template: `<div class='hierarchical-select' data-turbolinks-permanent>
  <div class='hierarchical-select-tree-container'>
    <hierarchical-select-tree
      v-for='tree in hierarchy.trees'
      :key='tree.id'
      :tree='tree'
      :selectedOrganizationId='selectedOrganizationId'
      :initialSelectedNodeAncestry='initialSelectedNodeAncestry'
      :profileSchema='profileSchema'
      @organizationDeleted='onOrganizationDeleted'
      @organizationSelected='onOrganizationSelected'
      ref='trees'/>
  </div>
</div>`,
  props: {
    initialSelectedNodeId: {
      type: [String, Number]
    },
    // [必填] 节点请求地址，级联选择格式
    resources: {
      type: String,
      required: true
    },
    profileSchema: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      hierarchy: new Skylark.Libs.Hierarchy(),
      initialSelectedNodeAncestry: []
    };
  },
  computed: {
    selectedOrganizationId: function() {
      return parseInt(this.initialSelectedNodeId, 10);
    }
  },
  created: function() {
    this.hierarchy.resources = this.resources;
    return this._initHierarchy(this.initialSelectedNodeId);
  },
  methods: {
    onOrganizationSelected: function(organization) {
      return this.$emit('organizationSelected', organization);
    },
    onOrganizationDeleted: function(organization) {
      var current_organization_id, roots;
      this.hierarchy.removeNode(organization);
      if (organization.id === this.selectedOrganizationId) {
        roots = this.hierarchy.getRootNodes();
        current_organization_id = roots.length > 0 ? _.first(roots).id : 'members';
        return this.$emit('organizationSelected', {
          id: current_organization_id
        });
      }
    },
    _initHierarchy: function(id = this.initialSelectedNodeId) {
      var extractRelationship, ids, reqUrl;
      id = parseInt(id);
      ids = id ? [id] : [];
      reqUrl = this._reqUrl(ids);
      this._setNodeParser(ids);
      extractRelationship = function(data, name) {
        return _.chain(data).map(function(node) {
          var ref;
          return (ref = node.relationships) != null ? ref[name] : void 0;
        }).flatten().compact().value();
      };
      return Skylark.Libs.Ajax.get(reqUrl, {
        responseType: 'json',
        success: (rsp) => {
          this.hierarchy.addNodes(rsp.included.roots);
          this.hierarchy.addNodes(extractRelationship(rsp.data, 'ancestors'));
          this.hierarchy.addNodes(extractRelationship(rsp.data, 'siblings'));
          this.hierarchy.addNodes(_.map(rsp.data, function(node) {
            return _.omit(node, 'relationships');
          }));
          this.hierarchy.nodeParser = function(node) {
            node._selected = false;
            return node;
          };
          return this.initialSelectedNodeAncestry = _.map(extractRelationship(rsp.data, 'ancestors'), function(node) {
            return node.id;
          });
        }
      });
    },
    _reqUrl: function(ids) {
      return Skylark.Helpers.UrlHelper.generateUrlWithParams(this.resources, {
        enhanced: true,
        ids: ids,
        include_roots: true,
        attach_ancestors: true,
        attach_siblings: !_.isEmpty(ids)
      });
    },
    _setNodeParser: function(ids) {
      return this.hierarchy.nodeParser = function(node) {
        if (_.includes(ids, node.id)) {
          node._selected = true;
        } else {
          node._selected = false;
        }
        return node;
      };
    }
  }
});
